module.exports = __webpack_public_path__ + "src/components/web-app-onboarding-complete/assets/web-extension.95d2a7ab4f33698efb747956b52b8e24.png";